export enum Status {
  Idle = "idle",
  Loading = "loading",
  Failed = "failed",
}

export type WithKey<T extends {}, U = string> = T & { key: U };
export type WithID<T extends {}, U = string> = T & { id: U };

export * from "./options";
export * from "./user";
export * from "./layout";
export * from "./api";
export * from "./views";
export * from "./event";
